export const getInjection = (function () {
    let ret: Record<string, string> = {};
    const $src = document.querySelector('[data-config-endpoints]') as HTMLScriptElement;
    try {
        ret = JSON.parse($src.innerText);
    } catch (error) {
        console.log('Unable to retrieve endpoint list');
        ret = {};
    }

    return ret;
})();
